import firebase from "firebase/compat/app";
import { getFunctions, httpsCallable } from "firebase/functions";
const bqGetMemberSummary = async function(userId, startDate, endDate) {
    const app = firebase.app();
    const functions = getFunctions(app, 'asia-east2');
    const queryThaisookViewBigQuery = httpsCallable(functions, 'queryThaisookViewBigQuery');

    const queryList = {
        'weightData': `
                    SELECT 
                        HD.date, 
                        HD.weight
                    FROM 
                        thaisook_view.healthdata HD
                    where 
                        HD.weight is not null
                        and HD.uid = '${userId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                    order by 
                        date 
        `,
        'bmiData': `
                    SELECT 
                        HD.date, 
                        HD.bmi
                    FROM 
                        thaisook_view.healthdata HD
                    where 
                        HD.bmi is not null
                        and HD.uid = '${userId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                    order by 
                        date 
        `,
        'pressureUpperData': `
                    SELECT 
                        HD.date, 
                        HD.pressureUpper
                    FROM 
                        thaisook_view.healthdata HD
                    where 
                        HD.pressureUpper is not null
                        and HD.uid = '${userId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                    order by HD.date 
        `,
        'pressureLowerData': `
                    SELECT 
                        HD.date, 
                        HD.pressureLower
                    FROM 
                        thaisook_view.healthdata HD
                    where 
                        HD.pressureLower is not null
                        and HD.uid = '${userId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                    order by HD.date 
        `,
        'fbsData': `
                    SELECT 
                        HD.date, 
                        HD.glucose fbs
                    FROM 
                        thaisook_view.healthdata HD
                    where 
                        HD.glucose is not null
                        and HD.uid = '${userId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                    order by HD.date 
        `,
        'ldlData': `
                    SELECT 
                        HD.date, 
                        HD.ldl
                    FROM 
                        thaisook_view.healthdata HD
                    where 
                        HD.ldl is not null
                        and HD.uid = '${userId}'
                        and date(HD.date) between '${startDate}' and '${endDate}'
                    order by HD.date 
        `,
        'workoutMins' : `
                    SELECT 
                        WO.date,
                        WO.totalWorkout workoutMins
                    FROM 
                        activity_view.workout WO
                    where 
                        WO.totalWorkout is not null
                        and WO.totalWorkout > 0
                        and WO.uid = '${userId}'
                        and date(WO.date) between '${startDate}' and '${endDate}'
                    order by WO.date
        `,
        'PBWF' : `
                    SELECT 
                        FO.date,
                        FO.serving
                    FROM 
                        thaisook_view.food FO
                    where 
                        FO.serving is not null
                        and FO.uid = '${userId}'
                        and date(FO.date) between '${startDate}' and '${endDate}'
                    order by FO.date
        `,
        'workoutMinsTotal' : `
                    SELECT 
                        sum(WO.totalWorkout) workoutMinsTotal
                    FROM 
                        activity_view.workout WO
                    where 
                        WO.totalWorkout is not null
                        and WO.totalWorkout > 0
                        and WO.uid = '${userId}'
                        and date(WO.date) between '${startDate}' and '${endDate}'

        `,
        'pbwfTotal' : `
                    SELECT 
                        sum(FO.serving) pbwfTotal
                    FROM 
                        thaisook_view.food FO
                    where 
                        FO.serving is not null
                        and FO.uid = '${userId}'
                        and date(FO.date) between '${startDate}' and '${endDate}'
                    group by FO.uid
        `
    };

    const result = await Promise.all([

        //0: get weight
        queryThaisookViewBigQuery({
            info: 'get weight data',
            query: queryList.weightData
        }), 

        //1: get bmi
        queryThaisookViewBigQuery({
            info: 'get bmi data',
            query: queryList.bmiData
        }), 

        //2: get pressureLower
        queryThaisookViewBigQuery({
            info: 'get pressureLower data',
            query: queryList.pressureLowerData
        }), 

        //3: get pressureUpper
        queryThaisookViewBigQuery({
            info: 'get pressureUpper data',
            query: queryList.pressureUpperData
        }), 

        //4: get fbs
        queryThaisookViewBigQuery({
            info: 'get fbs data',
            query: queryList.fbsData
        }), 

        //5: get ldl
        queryThaisookViewBigQuery({
            info: 'get ldl data',
            query: queryList.ldlData
        }),

        //6: get workout min
        queryThaisookViewBigQuery({
            info: 'get workout min data',
            query: queryList.workoutMins
        }),

        //7: get serving
        queryThaisookViewBigQuery({
            info: 'get serving data',
            query: queryList.PBWF
        }),

        //8: get total workout min
        queryThaisookViewBigQuery({
            info: 'get total workout min data',
            query: queryList.workoutMinsTotal
        }),

        //9: get total pbwf
        queryThaisookViewBigQuery({
            info: 'get total pbwf data',
            query: queryList.pbwfTotal
        })
    ]);

    let healthDataForChart = {
        weight: [],
        weightStart: 0,
        weightEnd: 0,
        weightMaxY: 0,
        bmi: [],
        bmiStart: 0,
        bmiEnd: 0,
        bmiMaxY: 0,
        pressureLower: [],
        pressureLowerStart: 0,
        pressureLowerEnd: 0,
        pressureUpper: [],
        pressureUpperStart: 0,
        pressureUpperEnd: 0,
        pressureMaxY: 0,
        ldl: [],
        ldlStart: 0,
        ldlEnd: 0,
        ldlMaxY: 0,
        fbs: [],
        fbsStart: 0,
        fbsEnd: 0,
        fbsMaxY: 0,
        workoutMins: [],
        workoutMinsTotal: 0,
        pbwf: [],
        pbwfTotal: 0,
    }

    const memberWeight = JSON.parse(result[0].data);
    if( memberWeight.length ){
        const memberWeightArray = memberWeight.reduce((tmp, doc) => {
            if( tmp['weight'] == undefined ){
                tmp = {
                    weight: [],
                    maxY: 0
                }
            }
            tmp['weight'].push([doc.date.value, doc.weight]);
            if( tmp.maxY < doc.weight*1 ){
                tmp.maxY = doc.weight*1;
            }
            if( healthDataForChart['weightStart'] == 0 ){
                healthDataForChart['weightStart'] = doc.weight;
                healthDataForChart['weightEnd'] = doc.weight;
            }
            healthDataForChart['weightEnd'] = doc.weight;
            return tmp;
        }, {});

        healthDataForChart['weight'] = memberWeightArray['weight'];
        healthDataForChart['weightMaxY'] = memberWeightArray['maxY'];
    }

    const memberBMI = JSON.parse(result[1].data);
    if( memberBMI.length ){
        const memberBMIArray = memberBMI.reduce((tmp, doc) => {
            if( tmp['bmi'] == undefined ){
                tmp = {
                    bmi: [],
                    maxY: 0
                }
            }
            tmp['bmi'].push([doc.date.value, doc.bmi]);
            if( tmp.maxY < doc.bmi*1 ){
                tmp.maxY = doc.bmi*1;
            }
            if( healthDataForChart['bmiStart'] == 0 ){
                healthDataForChart['bmiStart'] = doc.bmi;
                healthDataForChart['bmiEnd'] = doc.bmi;
            }
            healthDataForChart['bmiEnd'] = doc.bmi;
            return tmp;
        }, {});
        healthDataForChart['bmi'] = memberBMIArray['bmi'];
        healthDataForChart['bmiMaxY'] = memberBMIArray['maxY'];
    }

    const memberPressureLower = JSON.parse(result[2].data);
    if( memberPressureLower.length ){
        const memberPressureLowerArray = memberPressureLower.reduce((tmp, doc) => {
            if( tmp['pressureLower'] == undefined ){
                tmp = {
                    pressureLower: [],
                    maxY: 0
                }
            }
            tmp['pressureLower'].push([doc.date.value, doc.pressureLower]);
            if( tmp.maxY < doc.pressureLower*1 ){
                tmp.maxY = doc.pressureLower*1;
            }
            
            if( healthDataForChart['pressureLowerStart'] == 0 ){
                healthDataForChart['pressureLowerStart'] = doc.pressureLower;
                healthDataForChart['pressureLowerEnd'] = doc.pressureLower;
            }
            healthDataForChart['pressureLowerEnd'] = doc.pressureLower;
            return tmp;
        }, {});

        healthDataForChart['pressureLower'] = memberPressureLowerArray['pressureLower'];
    }

    const memberPressureUpper = JSON.parse(result[3].data);
    if( memberPressureUpper.length ){
        const memberPressureUpperArray = memberPressureUpper.reduce((tmp, doc) => {
            if( tmp['pressureUpper'] == undefined ){
                tmp = {
                    pressureUpper: [],
                    maxY: 0
                }
            }
            tmp['pressureUpper'].push([doc.date.value, doc.pressureUpper]);
            if( tmp.maxY < doc.pressureUpper*1 ){
                tmp.maxY = doc.pressureUpper*1;
            }
            if( healthDataForChart['pressureUpperStart'] == 0 ){
                healthDataForChart['pressureUpperStart'] = doc.pressureUpper;
                healthDataForChart['pressureUpperEnd'] = doc.pressureUpper;
            }
            healthDataForChart['pressureUpperEnd'] = doc.pressureUpper;
            return tmp;
        }, {});
        healthDataForChart['pressureUpper'] = memberPressureUpperArray['pressureUpper'];
        healthDataForChart['pressureMaxY'] = memberPressureUpperArray['maxY'];
    }

    const memberFBS = JSON.parse(result[4].data);
    if( memberFBS.length ){
        const memberFBSArray = memberFBS.reduce((tmp, doc) => {
            if( tmp['fbs'] == undefined ){
                tmp = {
                    fbs: [],
                    maxY: 0
                }
            }
            tmp['fbs'].push([doc.date.value, doc.fbs]);
            if( tmp.maxY < doc.fbs*1 ){
                tmp.maxY = doc.fbs*1;
            }
            if( healthDataForChart['fbsStart'] == 0 ){
                healthDataForChart['fbsStart'] = doc.fbs;
                healthDataForChart['fbsEnd'] = doc.fbs;
            }
            healthDataForChart['fbsEnd'] = doc.fbs;
            return tmp;
        }, {});
        healthDataForChart['fbs'] = memberFBSArray['fbs'];
        healthDataForChart['fbsMaxY'] = memberFBSArray['maxY'];
    }

    const memberLDL = JSON.parse(result[5].data);
    if( memberLDL.length ){
        const memberLDLArray = memberLDL.reduce((tmp, doc) => {
            if( tmp['ldl'] == undefined ){
                tmp = {
                    ldl: [],
                    maxY: 0
                }
            }
            tmp['ldl'].push([doc.date.value, doc.ldl]);
            if( tmp.maxY < doc.ldl*1 ){
                tmp.maxY = doc.ldl*1;
            }
            if( healthDataForChart['ldlStart'] == 0 ){
                healthDataForChart['ldlStart'] = doc.ldl;
                healthDataForChart['ldlEnd'] = doc.ldl;
            }
            healthDataForChart['ldlEnd'] = doc.ldl;
            return tmp;
        }, {});
        healthDataForChart['ldl'] = memberLDLArray['ldl'];
        healthDataForChart['ldlMaxY'] = memberLDLArray['maxY'];
    }

    const workoutMins = JSON.parse(result[6].data);
    if( workoutMins.length ){
        const workoutMinsArray = workoutMins.reduce((tmp, doc) => {
            if( tmp['workoutMins'] == undefined ){
                tmp = {
                    workoutMins: [],
                }
            }
            tmp['workoutMins'].push([doc.date.value, doc.workoutMins]);
            return tmp;
        }, {});
        healthDataForChart['workoutMins'] = workoutMinsArray['workoutMins'];
    }

    const pbwf = JSON.parse(result[7].data);
    if( pbwf.length ){
        const pbwfArray = pbwf.reduce((tmp, doc) => {
            if( tmp['pbwf'] == undefined ){
                tmp = {
                    pbwf: [],
                }
            }
            tmp['pbwf'].push([doc.date.value, doc.serving]);
            return tmp;
        }, {});
        healthDataForChart['pbwf'] = pbwfArray['pbwf'];
    }

    const workoutMinsTotal = JSON.parse(result[8].data);
    if( workoutMinsTotal.length ){
        healthDataForChart['workoutMinsTotal'] = workoutMinsTotal[0].workoutMinsTotal;
    }
    const pbwfTotal = JSON.parse(result[9].data);
    if( pbwfTotal.length ){
        healthDataForChart['pbwfTotal'] = pbwfTotal[0].pbwfTotal;
    }

    return healthDataForChart;
}

export default bqGetMemberSummary;